import React from 'react'
import SettingsManager from '../managers/settings'
import Bus from '../bus'

export const SettingsContext = React.createContext()
export const SettingsProvider = SettingsContext.Provider

export const useSettings = () => {
  return React.useContext(SettingsContext)
}

export const createSettings = () => {
  const [
    SettingsState,
    SettingsDispatcher
  ] = React.useState(SettingsManager.settings)

  React.useEffect(
    () => {
      function settingsUpdateHandler (settings) {
        SettingsDispatcher(settings)
      }

      Bus.addListener(
        Bus.events.settings.update,
        settingsUpdateHandler
      )

      return () => {
        Bus.removeListener(
          Bus.events.settings.update,
          settingsUpdateHandler
        )
      }
    },
    []
  )

  return SettingsState
}
